import { AddToCartItem, ProductBuilderMachineContext } from '../types';
import { getBaseProductType } from './getBaseProductType';
import { getCurtainAddonProducts } from './getCurtainAddonProducts';
import { getHoneycombAddonProducts } from './getHoneycombAddonProducts';
import { getRollerblindAddonProducts } from './getRollerblindAddonProducts';
import { getRomanAddonProducts } from './getRomanAddonProducts';
import { getVenetianAddonProducts } from './getVenetianAddonProducts';

type GetAddonProducts = (
  context: ProductBuilderMachineContext,
  upi: string,
  roomName: string,
  parentProductTitle: string,
) => AddToCartItem[];

export const getAddonProducts: GetAddonProducts = (
  context: ProductBuilderMachineContext,
  upi: string,
  roomName: string,
  parentProductTitle: string,
) => {
  const productType = getBaseProductType(context);
  const addonProducts =
    productType === 'Honeycomb'
      ? getHoneycombAddonProducts(context, upi, roomName, parentProductTitle)
      : productType === 'Curtain'
      ? getCurtainAddonProducts(context, upi, roomName, parentProductTitle)
      : productType === 'Roller Blind'
      ? getRollerblindAddonProducts(context, upi, roomName, parentProductTitle)
      : productType === 'Roman Blinds'
      ? getRomanAddonProducts(context, upi, roomName, parentProductTitle)
      : productType === 'Venetian'
      ? getVenetianAddonProducts(context, upi, roomName, parentProductTitle)
      : [];
  return addonProducts;
};
